var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup696(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_696",
    "data-name": "Group 696",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.791,
    height: 35.152,
    viewBox: "0 0 42.791 35.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M-237.9,261.854v-.547c0-1.607,0-3.215,0-4.822a1.53,1.53,0,0,1,1.518-1.615,1.529,1.529,0,0,1,1.532,1.6q.006,4.488,0,8.976a1.52,1.52,0,0,1-.99,1.535,1.481,1.481,0,0,1-1.693-.413c-1.753-1.758-3.512-3.511-5.255-5.278a1,1,0,0,0-.791-.321q-6.422.015-12.844.007a4.188,4.188,0,0,1-4.4-4.4q0-5.563,0-11.125a4.178,4.178,0,0,1,4.325-4.334q8.666,0,17.332,0a4.181,4.181,0,0,1,4.317,4.294q0,2.363,0,4.727a1.543,1.543,0,0,1-1.512,1.671,1.546,1.546,0,0,1-1.54-1.692c0-1.544,0-3.088,0-4.632a1.167,1.167,0,0,0-1.322-1.316q-8.595,0-17.189,0c-.936,0-1.357.429-1.357,1.378q0,5.515,0,11.03a1.178,1.178,0,0,0,1.34,1.348q6.852,0,13.7-.006a1.929,1.929,0,0,1,1.487.609c.964.993,1.951,1.966,2.929,2.945C-238.2,261.581-238.087,261.681-237.9,261.854Z",
    transform: "translate(277.636 -231.945)",
    fill: "#575556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M-433.763,168.867c1.124-1.115,2.218-2.179,3.285-3.27a1.97,1.97,0,0,1,1.528-.628c1.893.021,3.787.006,5.681.008a1.545,1.545,0,0,1,1.7,1.536,1.553,1.553,0,0,1-1.715,1.517c-1.623,0-3.246.009-4.87-.007a.945.945,0,0,0-.744.316q-2.585,2.614-5.19,5.208a1.522,1.522,0,0,1-1.8.477,1.586,1.586,0,0,1-.961-1.607q.01-11.506,0-23.012a4.174,4.174,0,0,1,4.269-4.292q10.241-.005,20.482,0a4.179,4.179,0,0,1,4.28,4.283c0,.6.008,1.21,0,1.814a1.53,1.53,0,0,1-1.548,1.539,1.531,1.531,0,0,1-1.5-1.538c-.01-.6,0-1.209,0-1.814a1.141,1.141,0,0,0-1.215-1.229q-10.241-.006-20.482,0a1.127,1.127,0,0,0-1.224,1.172q-.008,9.668,0,19.336A1.482,1.482,0,0,0-433.763,168.867Z",
    transform: "translate(436.856 -145.11)",
    fill: "#575556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup696);
export default __webpack_public_path__ + "static/media/Group 696.8e56e9541e5b0d1042cca1096e4a7459.svg";
export { ForwardRef as ReactComponent };